import { Card } from "../../reportDashboard/common/Card";

function SummaryCardShimmer() {
  return [...Array(3)].map((_, idx) => (
    <Card
      key={idx}
      className="p-6 bg-white rounded-lg shadow-sm border border-gray-100 animate-pulse"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="h-4 w-32 bg-gray-200 rounded"></div>
        <div className="w-10 h-10 rounded-lg bg-gray-200" />
      </div>
      <div className="space-y-2">
        <div className="h-6 w-24 bg-gray-200 rounded"></div>
        <div className="h-4 w-32 bg-gray-200 rounded"></div>
        <div className="h-3 w-20 bg-gray-200 rounded"></div>
      </div>
    </Card>
  ));
}

export default SummaryCardShimmer;
